module.exports = __webpack_public_path__ + "static/media/logo-premedashboard.191abea6.svg";